import { createContext, useRef, useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  __defProp(target, "default", { value: mod, enumerable: true }) ,
  mod
));

// ../shared-ws-lib/dist/types/index.js
var require_types = __commonJS({
  "../shared-ws-lib/dist/types/index.js"(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.REALTIME_EXCHANGE = exports.RealtimeTopics = exports.TopicSubtype = exports.TopicPrefix = exports.EventType = void 0;
    exports.EventType = {
      // Messenger events
      MESSAGE_RECEIVED: "MESSAGE_RECEIVED",
      MESSAGE_READ: "MESSAGE_READ",
      TYPING_STARTED: "TYPING_STARTED",
      TYPING_STOPPED: "TYPING_STOPPED",
      // PGW events
      PAYMENT_STATUS_CHANGED: "PAYMENT_STATUS_CHANGED",
      PAYMENT_RECEIVED: "PAYMENT_RECEIVED",
      PAYMENT_CONFIRMED: "PAYMENT_CONFIRMED",
      PAYMENT_EXPIRED: "PAYMENT_EXPIRED",
      PAYMENT_PARTIAL: "PAYMENT_PARTIAL",
      // Merchant events
      ORDER_CREATED: "ORDER_CREATED",
      ORDER_STATUS_CHANGED: "ORDER_STATUS_CHANGED",
      LOW_STOCK_ALERT: "LOW_STOCK_ALERT",
      INVENTORY_UPDATED: "INVENTORY_UPDATED",
      // Product sync events (Catalog → Frontend real-time)
      PRICE_UPDATED: "PRICE_UPDATED",
      STOCK_UPDATED: "STOCK_UPDATED",
      // Collection sync events (Merchant Backend → Storefront real-time)
      COLLECTION_UPDATED: "COLLECTION_UPDATED",
      // Appearance events (APRN-11: Carousel & Featured Products → Storefront real-time)
      CAROUSEL_UPDATED: "CAROUSEL_UPDATED",
      FEATURED_PRODUCTS_UPDATED: "FEATURED_PRODUCTS_UPDATED",
      // Favorites events
      FAVORITE_ADDED: "FAVORITE_ADDED",
      FAVORITE_REMOVED: "FAVORITE_REMOVED",
      // Preferences events
      PREFERENCES_UPDATED: "PREFERENCES_UPDATED",
      // Cart events
      CART_UPDATED: "CART_UPDATED",
      CART_AGGREGATION_UPDATED: "CART_AGGREGATION_UPDATED",
      // Review events (REV-9)
      REVIEW_SUBMITTED: "REVIEW_SUBMITTED",
      REVIEW_UPDATED: "REVIEW_UPDATED",
      REVIEW_DELETED: "REVIEW_DELETED",
      REVIEW_REPLIED: "REVIEW_REPLIED",
      // Enrichment admin events (ESS-7)
      ENRICHMENT_JOB_PROGRESS: "ENRICHMENT_JOB_PROGRESS",
      ENRICHMENT_JOB_COMPLETED: "ENRICHMENT_JOB_COMPLETED",
      WORKER_STATUS_CHANGED: "WORKER_STATUS_CHANGED",
      // System events
      SYSTEM_NOTIFICATION: "SYSTEM_NOTIFICATION",
      SYSTEM_BROADCAST: "SYSTEM_BROADCAST"
    };
    exports.TopicPrefix = {
      USER: "user",
      MERCHANT: "merchant",
      PAYMENT: "payment",
      SYSTEM: "system"
    };
    exports.TopicSubtype = {
      MESSAGES: "messages",
      NOTIFICATIONS: "notifications",
      ORDERS: "orders",
      ANALYTICS: "analytics",
      INVENTORY: "inventory",
      STATUS: "status",
      BROADCAST: "broadcast",
      FAVORITES: "favorites",
      PREFERENCES: "preferences",
      CARTS: "carts",
      REVIEWS: "reviews"
    };
    exports.RealtimeTopics = {
      /**
       * Build user messages topic: user.{userGuid}.messages
       */
      userMessages: (userGuid) => `user.${userGuid}.messages`,
      /**
       * Build user notifications topic: user.{userGuid}.notifications
       */
      userNotifications: (userGuid) => `user.${userGuid}.notifications`,
      /**
       * Build merchant orders topic: merchant.{merchantGuid}.orders
       */
      merchantOrders: (merchantGuid) => `merchant.${merchantGuid}.orders`,
      /**
       * Build merchant analytics topic: merchant.{merchantGuid}.analytics
       */
      merchantAnalytics: (merchantGuid) => `merchant.${merchantGuid}.analytics`,
      /**
       * Build merchant inventory topic: merchant.{merchantGuid}.inventory
       */
      merchantInventory: (merchantGuid) => `merchant.${merchantGuid}.inventory`,
      /**
       * Build merchant messages topic: merchant.{merchantGuid}.messages
       */
      merchantMessages: (merchantGuid) => `merchant.${merchantGuid}.messages`,
      /**
       * Build payment status topic: payment.{orderGuid}.status
       */
      paymentStatus: (orderGuid) => `payment.${orderGuid}.status`,
      /**
       * System broadcast topic
       */
      systemBroadcast: () => "system.broadcast",
      /**
       * Build user favorites topic: user.{userGuid}.favorites
       */
      userFavorites: (userGuid) => `user.${userGuid}.favorites`,
      /**
       * Build user preferences topic: user.{userGuid}.preferences
       */
      userPreferences: (userGuid) => `user.${userGuid}.preferences`,
      /**
       * Build user carts topic: user.{userGuid}.carts
       */
      userCarts: (userGuid) => `user.${userGuid}.carts`,
      /** Build user reviews topic: user.{userGuid}.reviews (REV-9) */
      userReviews: (userGuid) => `user.${userGuid}.reviews`,
      /** Build merchant reviews topic: merchant.{merchantGuid}.reviews (REV-9) */
      merchantReviews: (merchantGuid) => `merchant.${merchantGuid}.reviews`,
      /** Enrichment admin topic: catalog.enrichment.admin (ESS-7) */
      enrichmentAdmin: () => "catalog.enrichment.admin"
    };
    exports.REALTIME_EXCHANGE = {
      NAME: "realtime.events",
      TYPE: "topic",
      DURABLE: true
    };
  }
});

// src/types/index.ts
__toESM(require_types());
var ClientMessageType = {
  SUBSCRIBE: "SUBSCRIBE",
  UNSUBSCRIBE: "UNSUBSCRIBE",
  PING: "PING"
};
var ServerMessageType = {
  CONNECTED: "CONNECTED",
  // Initial connection acknowledgment
  AUTH_SUCCESS: "AUTH_OK",
  // Server sends AUTH_OK, not AUTH_SUCCESS
  AUTH_ERROR: "AUTH_FAIL",
  // Server sends AUTH_FAIL, not AUTH_ERROR
  SUBSCRIBED: "SUBSCRIBED",
  UNSUBSCRIBED: "UNSUBSCRIBED",
  EVENT: "EVENT",
  PONG: "PONG",
  ERROR: "ERROR"
};
var InternalEventType = {
  CONNECTED: "__CONNECTED__",
  DISCONNECTED: "__DISCONNECTED__",
  RECONNECTING: "__RECONNECTING__",
  RECONNECTED: "__RECONNECTED__",
  ERROR: "__ERROR__"
};

// src/core/TeletiendaWS.ts
var DEFAULT_OPTIONS = {
  reconnect: true,
  reconnectInterval: 3e3,
  maxReconnectInterval: 3e4,
  maxReconnectAttempts: 5,
  heartbeatInterval: 3e4,
  connectionTimeout: 1e4
};
var TeletiendaWS = class {
  constructor(options) {
    this._ws = null;
    this._connectionState = "disconnected";
    this._reconnectAttempts = 0;
    this._reconnectTimer = null;
    this._heartbeatTimer = null;
    this._connectionTimeoutTimer = null;
    this._subscriptions = /* @__PURE__ */ new Set();
    this._pendingSubscriptions = /* @__PURE__ */ new Set();
    this._eventListeners = /* @__PURE__ */ new Map();
    this._isAuthenticated = false;
    this._intentionalDisconnect = false;
    this._url = options.url;
    this._token = options.token;
    this._options = { ...DEFAULT_OPTIONS, ...options };
  }
  /**
   * Get current connection state
   */
  get connectionState() {
    return this._connectionState;
  }
  /**
   * Check if connected
   */
  get isConnected() {
    return this._connectionState === "connected" && this._isAuthenticated;
  }
  /**
   * Get active subscriptions
   */
  get subscriptions() {
    return Array.from(this._subscriptions);
  }
  /**
   * Update authentication token (triggers reconnect if connected)
   * Validates token before attempting reconnect to prevent AUTH_FAIL race conditions
   */
  updateToken(newToken) {
    if (newToken === this._token) {
      console.log("[TeletiendaWS] Token unchanged, skipping reconnect");
      return;
    }
    if (!newToken || newToken.length < 20) {
      console.warn("[TeletiendaWS] Invalid/empty token received, disconnecting");
      this.disconnect();
      return;
    }
    const previousToken = this._token;
    this._token = newToken;
    if (this._connectionState === "connected") {
      console.log("[TeletiendaWS] Token updated while connected, reconnecting with new token", {
        previousTokenPreview: previousToken ? `${previousToken.slice(0, 20)}...` : "none",
        newTokenPreview: `${newToken.slice(0, 20)}...`
      });
      this._intentionalDisconnect = false;
      this._cleanup();
      this._setConnectionState("disconnected");
      this.connect().catch((err) => {
        console.error("[TeletiendaWS] Reconnect after token update failed:", err);
      });
    }
  }
  /**
   * Connect to WebSocket server
   */
  async connect() {
    console.log("[TeletiendaWS] connect() called, current state:", this._connectionState);
    if (this._connectionState === "connected" || this._connectionState === "connecting") {
      console.log("[TeletiendaWS] Already connected/connecting, skipping");
      return;
    }
    this._intentionalDisconnect = false;
    console.log("[TeletiendaWS] Calling _connect()");
    return this._connect();
  }
  /**
   * Disconnect from WebSocket server
   */
  disconnect() {
    this._intentionalDisconnect = true;
    this._cleanup();
    this._setConnectionState("disconnected");
    this._emit(InternalEventType.DISCONNECTED, void 0);
  }
  /**
   * Subscribe to topics
   */
  subscribe(topics) {
    console.log("[TeletiendaWS] subscribe() called:", { topics, isConnected: this.isConnected });
    const topicsArray = Array.isArray(topics) ? topics : [topics];
    for (const topic of topicsArray) {
      if (!this._subscriptions.has(topic)) {
        this._pendingSubscriptions.add(topic);
      }
    }
    if (this.isConnected) {
      console.log("[TeletiendaWS] subscribe(): connected, sending subscribe");
      this._sendSubscribe(topicsArray);
    } else {
      console.log("[TeletiendaWS] subscribe(): not connected, queued pending");
    }
  }
  /**
   * Unsubscribe from topics
   */
  unsubscribe(topics) {
    const topicsArray = Array.isArray(topics) ? topics : [topics];
    for (const topic of topicsArray) {
      this._subscriptions.delete(topic);
      this._pendingSubscriptions.delete(topic);
    }
    if (this.isConnected) {
      this._sendUnsubscribe(topicsArray);
    }
  }
  /**
   * Register event listener
   * Returns unsubscribe function
   */
  on(event, callback) {
    if (!this._eventListeners.has(event)) {
      this._eventListeners.set(event, /* @__PURE__ */ new Set());
    }
    const listeners = this._eventListeners.get(event);
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
      if (listeners.size === 0) {
        this._eventListeners.delete(event);
      }
    };
  }
  /**
   * Register connection event listeners (convenience methods)
   */
  onConnected(callback) {
    return this.on(InternalEventType.CONNECTED, callback);
  }
  onDisconnected(callback) {
    return this.on(InternalEventType.DISCONNECTED, callback);
  }
  onReconnecting(callback) {
    return this.on(InternalEventType.RECONNECTING, callback);
  }
  onReconnected(callback) {
    return this.on(InternalEventType.RECONNECTED, callback);
  }
  onError(callback) {
    return this.on(InternalEventType.ERROR, callback);
  }
  // Private methods
  async _connect() {
    console.log("[TeletiendaWS] _connect() starting, url:", this._url);
    return new Promise((resolve, reject) => {
      try {
        this._setConnectionState("connecting");
        const url = new URL(this._url);
        url.searchParams.set("token", this._token);
        console.log("[TeletiendaWS] Creating WebSocket to:", url.toString().slice(0, 100) + "...");
        this._ws = new WebSocket(url.toString());
        this._connectionTimeoutTimer = setTimeout(() => {
          if (this._connectionState === "connecting") {
            this._ws?.close();
            const error = new Error("Connection timeout");
            this._emit(InternalEventType.ERROR, error);
            reject(error);
          }
        }, this._options.connectionTimeout);
        this._ws.onopen = () => {
          this._clearConnectionTimeout();
        };
        this._ws.onmessage = (event) => {
          this._handleMessage(event.data, resolve);
        };
        this._ws.onerror = (_event) => {
          this._clearConnectionTimeout();
          const error = new Error("WebSocket error");
          this._emit(InternalEventType.ERROR, error);
          if (this._connectionState === "connecting") {
            reject(error);
          }
        };
        this._ws.onclose = (_event) => {
          this._handleClose();
        };
      } catch (error) {
        this._clearConnectionTimeout();
        reject(error);
      }
    });
  }
  _handleMessage(data, connectResolve) {
    try {
      const message = JSON.parse(data);
      console.log("[TeletiendaWS] Message received:", message.type);
      switch (message.type) {
        case ServerMessageType.CONNECTED:
          console.log("[TeletiendaWS] CONNECTED received, waiting for AUTH_OK");
          break;
        case ServerMessageType.AUTH_SUCCESS:
          console.log("[TeletiendaWS] AUTH_OK received");
          this._handleAuthSuccess(connectResolve);
          break;
        case ServerMessageType.AUTH_ERROR:
          console.log("[TeletiendaWS] AUTH_FAIL received:", message.payload);
          this._handleAuthError(message.payload);
          break;
        case ServerMessageType.SUBSCRIBED:
          console.log("[TeletiendaWS] SUBSCRIBED to topics:", message.payload.topics);
          this._handleSubscribed(message.payload.topics);
          break;
        case ServerMessageType.UNSUBSCRIBED:
          console.log("[TeletiendaWS] UNSUBSCRIBED:", message.payload.removed);
          break;
        case ServerMessageType.EVENT:
          this._handleEvent(message);
          break;
        case ServerMessageType.PONG:
          break;
        case ServerMessageType.ERROR:
          console.log("[TeletiendaWS] ERROR received:", message.error);
          this._emit(InternalEventType.ERROR, new Error(`${message.error.code}: ${message.error.message}`));
          break;
      }
    } catch {
      console.error("[TeletiendaWS] Failed to parse message:", data);
    }
  }
  _handleAuthSuccess(connectResolve) {
    this._isAuthenticated = true;
    this._reconnectAttempts = 0;
    const wasReconnecting = this._connectionState === "reconnecting";
    this._setConnectionState("connected");
    this._startHeartbeat();
    if (this._subscriptions.size > 0 || this._pendingSubscriptions.size > 0) {
      const allTopics = [...this._subscriptions, ...this._pendingSubscriptions];
      this._sendSubscribe(allTopics);
    }
    if (wasReconnecting) {
      this._emit(InternalEventType.RECONNECTED, void 0);
    } else {
      this._emit(InternalEventType.CONNECTED, void 0);
    }
    connectResolve?.();
  }
  _handleAuthError(payload) {
    this._isAuthenticated = false;
    const authError = new Error(`${payload.code}: ${payload.message}`);
    this._emit(InternalEventType.ERROR, authError);
    this._cleanup();
    this._setConnectionState("disconnected");
  }
  _handleSubscribed(topics) {
    for (const topic of topics) {
      this._subscriptions.add(topic);
      this._pendingSubscriptions.delete(topic);
    }
  }
  _handleEvent(message) {
    const { payload } = message;
    console.log("[TeletiendaWS] _handleEvent:", { payload });
    if (payload.event) {
      console.log("[TeletiendaWS] Emitting event:", payload.event, "with data:", payload.data);
      this._emit(payload.event, payload.data);
    } else {
      console.log("[TeletiendaWS] No event field in payload");
    }
  }
  _handleClose() {
    this._clearHeartbeat();
    this._isAuthenticated = false;
    if (this._intentionalDisconnect) {
      this._setConnectionState("disconnected");
      this._emit(InternalEventType.DISCONNECTED, void 0);
      return;
    }
    if (this._options.reconnect && this._reconnectAttempts < this._options.maxReconnectAttempts) {
      this._scheduleReconnect();
    } else {
      this._setConnectionState("disconnected");
      this._emit(InternalEventType.DISCONNECTED, void 0);
    }
  }
  _scheduleReconnect() {
    this._setConnectionState("reconnecting");
    this._emit(InternalEventType.RECONNECTING, void 0);
    const delay = Math.min(
      this._options.reconnectInterval * Math.pow(2, this._reconnectAttempts),
      this._options.maxReconnectInterval
    );
    this._reconnectAttempts++;
    this._reconnectTimer = setTimeout(async () => {
      try {
        await this._connect();
      } catch {
      }
    }, delay);
  }
  _sendSubscribe(topics) {
    console.log("[TeletiendaWS] _sendSubscribe called with topics:", topics);
    if (topics.length === 0) {
      console.log("[TeletiendaWS] _sendSubscribe: empty topics, skipping");
      return;
    }
    const message = {
      type: ClientMessageType.SUBSCRIBE,
      payload: { topics }
      // Server expects payload.topics
    };
    console.log("[TeletiendaWS] Sending SUBSCRIBE:", message);
    this._send(message);
  }
  _sendUnsubscribe(topics) {
    if (topics.length === 0) return;
    this._send({
      type: ClientMessageType.UNSUBSCRIBE,
      payload: { topics }
      // Server expects payload.topics
    });
  }
  _startHeartbeat() {
    this._clearHeartbeat();
    this._heartbeatTimer = setInterval(() => {
      if (this.isConnected) {
        this._send({ type: ClientMessageType.PING });
      }
    }, this._options.heartbeatInterval);
  }
  _clearHeartbeat() {
    if (this._heartbeatTimer) {
      clearInterval(this._heartbeatTimer);
      this._heartbeatTimer = null;
    }
  }
  _clearConnectionTimeout() {
    if (this._connectionTimeoutTimer) {
      clearTimeout(this._connectionTimeoutTimer);
      this._connectionTimeoutTimer = null;
    }
  }
  _clearReconnectTimer() {
    if (this._reconnectTimer) {
      clearTimeout(this._reconnectTimer);
      this._reconnectTimer = null;
    }
  }
  _cleanup() {
    this._clearHeartbeat();
    this._clearConnectionTimeout();
    this._clearReconnectTimer();
    if (this._ws) {
      this._ws.onopen = null;
      this._ws.onmessage = null;
      this._ws.onerror = null;
      this._ws.onclose = null;
      if (this._ws.readyState === WebSocket.OPEN || this._ws.readyState === WebSocket.CONNECTING) {
        this._ws.close();
      }
      this._ws = null;
    }
    this._isAuthenticated = false;
  }
  _send(data) {
    if (this._ws?.readyState === WebSocket.OPEN) {
      this._ws.send(JSON.stringify(data));
    }
  }
  _setConnectionState(state) {
    this._connectionState = state;
  }
  _emit(event, data) {
    const listeners = this._eventListeners.get(event);
    if (listeners) {
      for (const callback of listeners) {
        try {
          callback(data);
        } catch (error) {
          console.error(`[TeletiendaWS] Error in event listener for ${event}:`, error);
        }
      }
    }
  }
};
var WebSocketContext = createContext(null);
function WebSocketProvider({
  options,
  children,
  autoConnect = true
}) {
  const clientRef = useRef(null);
  const [connectionState, setConnectionState] = useState("disconnected");
  const prevTokenRef = useRef(options.token);
  const isMountedRef = useRef(false);
  console.log("[WebSocketProvider] Render:", {
    autoConnect,
    url: options.url,
    hasToken: !!options.token,
    tokenLength: options.token?.length
  });
  useEffect(() => {
    console.log("[WebSocketProvider] useEffect running, autoConnect:", autoConnect);
    isMountedRef.current = true;
    setConnectionState("disconnected");
    const client = new TeletiendaWS(options);
    clientRef.current = client;
    console.log("[WebSocketProvider] Client created");
    const unsubConnected = client.onConnected(() => {
      if (isMountedRef.current) {
        setConnectionState("connected");
      }
    });
    const unsubDisconnected = client.onDisconnected(() => {
      if (isMountedRef.current) {
        setConnectionState("disconnected");
      }
    });
    const unsubReconnecting = client.onReconnecting(() => {
      if (isMountedRef.current) {
        setConnectionState("reconnecting");
      }
    });
    const unsubReconnected = client.onReconnected(() => {
      if (isMountedRef.current) {
        setConnectionState("connected");
      }
    });
    if (autoConnect) {
      console.log("[WebSocketProvider] Setting up auto-connect timer");
      const connectTimer = setTimeout(() => {
        console.log("[WebSocketProvider] Timer fired:", {
          isMounted: isMountedRef.current,
          hasClient: !!clientRef.current
        });
        if (isMountedRef.current && clientRef.current) {
          console.log("[WebSocketProvider] Calling client.connect()");
          client.connect().catch((err) => {
            console.error("[WebSocketProvider] Connect error:", err);
          });
        } else {
          console.log("[WebSocketProvider] Skipping connect - unmounted or no client");
        }
      }, 100);
      return () => {
        clearTimeout(connectTimer);
        isMountedRef.current = false;
        unsubConnected();
        unsubDisconnected();
        unsubReconnecting();
        unsubReconnected();
        client.disconnect();
        clientRef.current = null;
      };
    }
    return () => {
      isMountedRef.current = false;
      unsubConnected();
      unsubDisconnected();
      unsubReconnecting();
      unsubReconnected();
      client.disconnect();
      clientRef.current = null;
    };
  }, [options.url, autoConnect]);
  useEffect(() => {
    if (clientRef.current && options.token !== prevTokenRef.current) {
      prevTokenRef.current = options.token;
      clientRef.current.updateToken(options.token);
    }
  }, [options.token]);
  const subscribe = useCallback((topics) => {
    console.log("[WebSocketProvider] subscribe called:", {
      topics,
      hasClient: !!clientRef.current,
      isConnected: clientRef.current?.isConnected
    });
    clientRef.current?.subscribe(topics);
  }, []);
  const unsubscribe = useCallback((topics) => {
    clientRef.current?.unsubscribe(topics);
  }, []);
  const on = useCallback(
    (event, callback) => {
      return clientRef.current?.on(event, callback) ?? (() => {
      });
    },
    []
  );
  const contextValue = useMemo(
    () => ({
      client: clientRef.current,
      connectionState,
      isConnected: connectionState === "connected",
      subscribe,
      unsubscribe,
      on
    }),
    [connectionState, subscribe, unsubscribe, on]
  );
  return /* @__PURE__ */ jsx(WebSocketContext.Provider, { value: contextValue, children });
}
function useWebSocketContext() {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error("useWebSocketContext must be used within a WebSocketProvider");
  }
  return context;
}
var DEFAULT_WEBSOCKET_RETURN = {
  isConnected: false,
  connectionState: "disconnected",
  subscribe: () => {
  },
  unsubscribe: () => {
  },
  on: () => () => {
  }
};
function useWebSocket() {
  const context = useWebSocketContext();
  return {
    isConnected: context.isConnected,
    connectionState: context.connectionState,
    subscribe: context.subscribe,
    unsubscribe: context.unsubscribe,
    on: context.on
  };
}
function useWebSocketOptional() {
  const context = useContext(WebSocketContext);
  if (!context) {
    return DEFAULT_WEBSOCKET_RETURN;
  }
  return {
    isConnected: context.isConnected,
    connectionState: context.connectionState,
    subscribe: context.subscribe,
    unsubscribe: context.unsubscribe,
    on: context.on
  };
}
function useRealtimeEvent(event, callback, deps = [], options = {}) {
  const { requireConnection = true } = options;
  const { isConnected, on } = useWebSocketContext();
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    console.log("[useRealtimeEvent] Effect running:", { event, isConnected, requireConnection });
    if (requireConnection && !isConnected) {
      console.log("[useRealtimeEvent] Skipping - not connected");
      return;
    }
    console.log("[useRealtimeEvent] Subscribing to event:", event);
    const unsubscribe = on(event, (data) => {
      console.log("[useRealtimeEvent] Event received:", event, data);
      callbackRef.current(data);
    });
    return unsubscribe;
  }, [event, isConnected, on, requireConnection, ...deps]);
}
function useRealtimeEvents(events, callback, deps = []) {
  const { isConnected, on } = useWebSocketContext();
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    if (!isConnected) {
      return;
    }
    const unsubscribers = events.map(
      (event) => on(event, (data) => {
        callbackRef.current(data, event);
      })
    );
    return () => {
      unsubscribers.forEach((unsub) => unsub());
    };
  }, [isConnected, on, ...events, ...deps]);
}
function useRealtimeEventOptional(event, callback, deps = [], options = {}) {
  const { requireConnection = true } = options;
  const context = useContext(WebSocketContext);
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    if (!context) {
      console.log("[useRealtimeEventOptional] No context - gracefully skipping");
      return;
    }
    const { isConnected, on } = context;
    console.log("[useRealtimeEventOptional] Effect running:", { event, isConnected, requireConnection });
    if (requireConnection && !isConnected) {
      console.log("[useRealtimeEventOptional] Skipping - not connected");
      return;
    }
    console.log("[useRealtimeEventOptional] Subscribing to event:", event);
    const unsubscribe = on(event, (data) => {
      console.log("[useRealtimeEventOptional] Event received:", event, data);
      callbackRef.current(data);
    });
    return unsubscribe;
  }, [event, context, requireConnection, ...deps]);
}

// src/react/index.ts
var import_types3 = __toESM(require_types());
var export_EventType = import_types3.EventType;
var export_RealtimeTopics = import_types3.RealtimeTopics;

export { export_EventType as EventType, export_RealtimeTopics as RealtimeTopics, WebSocketContext, WebSocketProvider, useRealtimeEvent, useRealtimeEventOptional, useRealtimeEvents, useWebSocket, useWebSocketContext, useWebSocketOptional };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map